import { apiSlice } from './apiSlice';

const ZERODHA_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;

export const zerodhaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Define the dashboardCalculation mutation
    dashboardCalculation: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/dashboardCalculation`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    lincfolioScore: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/lincfolioScore`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    runningPnl: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/runningpnl`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    dailyPnl: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/dailypnl`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    dailyJournal: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/dailjournalData`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    dailyJournalbydate: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/dailjournaldatabydate`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    tradelogs: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/tradelogdata`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    smallcalendar: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/smallcalendardates`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    report: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/report`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    saveNote: builder.mutation({
      query: (data) => ({
        url: `${ZERODHA_URL}/angel-one/saveNote`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
    //   uploadCsv: builder.mutation({
    //   query: (data) => ({
    //     url: `${ZERODHA_URL}/uploadcsv`,
    //     method: 'POST',
    //     body: data,
    //     credentials: "include",
    //   }),
    // }),
  }),
});

// Export the mutation hook for use in components
export const {
  useDashboardCalculationMutation,
  useLincfolioScoreMutation,
  useRunningPnlMutation, 
  useDailyPnlMutation,
  useDailyJournalMutation, 
  useTradelogsMutation,
  useSmallcalendarMutation,
  useDailyJournalbydateMutation,
  useReportMutation,
  useSaveNoteMutation,
  // useUploadCsvMutation
} = zerodhaApiSlice;
